import React, { useState } from "react";
import CommentBlock from "./CommentBlock";
import LoadingSpinner from "./LoadingSpinner";

export default function CommentsSection({
  comments,
  onCommentSubmit,
  onCommentDelete,
  currentUser,
  isSubmitting = false,
  withoutDelete = false,
}) {
  const [newComment, setNewComment] = useState("");
  const [visibleComments, setVisibleComments] = useState(5);

  const handleChange = (e) => {
    setNewComment(e.target.value);
  };

  const handleSubmit = async () => {
    if (!newComment.trim()) return;

    await onCommentSubmit(newComment);
    setNewComment("");
  };

  const handleSeeMore = () => {
    setVisibleComments((prev) => prev + 5);
  };

  // If comments is undefined or null, use an empty array
  const commentsData = comments || [];
  // Slice the data to only show the most recent items
  const visibleData = commentsData.slice(-visibleComments).reverse();
  // Calculate remaining unseen items
  const unseenCount = commentsData.length - visibleComments;

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden">
      <div className="border-b border-gray-100 p-4">
        <h3 className="font-semibold text-lg text-[#363062]">Comments</h3>
      </div>
      <div className="p-6">
        <div className="mb-6">
          <textarea
            name="newComment"
            className="w-full rounded-lg p-4 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#363062] focus:border-transparent resize-none"
            rows="3"
            onChange={handleChange}
            placeholder="Write your comment here..."
            value={newComment}
          ></textarea>
          <div className="flex justify-end mt-3">
            <button
              className="px-6 py-2.5 bg-[#8FCD00] text-white rounded-lg hover:bg-opacity-90 disabled:opacity-50 disabled:cursor-not-allowed font-medium shadow-sm flex items-center justify-center min-w-[140px]"
              onClick={handleSubmit}
              disabled={!newComment.trim() || isSubmitting}
            >
              {isSubmitting ? (
                <LoadingSpinner text="Submitting..." />
              ) : (
                "Submit Comment"
              )}
            </button>
          </div>
        </div>

        <div className="space-y-4 text-sm">
          {visibleData.map((comment, index) => (
            <CommentBlock
              key={index}
              comment={comment}
              currentUser={currentUser}
              handleDeleteComment={() => onCommentDelete(comment.id)}
              withoutDelete={withoutDelete}
            />
          ))}
        </div>

        {/* Show "See More" button only if there are more items to display */}
        {visibleComments < commentsData.length && (
          <div className="mt-4 text-center">
            <button
              onClick={handleSeeMore}
              className="text-[#363062] hover:text-blue-700 text-sm font-medium"
            >
              See More ({unseenCount} more)
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
